import { render, staticRenderFns } from "./MasterProposalCp.vue?vue&type=template&id=51dd7829&scoped=true&"
import script from "./MasterProposalCp.vue?vue&type=script&lang=js&"
export * from "./MasterProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposalCp.vue?vue&type=style&index=0&id=51dd7829&prod&scoped=true&lang=scss&"
import style1 from "./MasterProposalCp.vue?vue&type=style&index=1&id=51dd7829&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd7829",
  null
  
)

export default component.exports